import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-view-emergency-info',
  templateUrl: './view-emergency-info.component.html',
  styleUrls: ['./view-emergency-info.component.scss']
})
export class ViewEmergencyInfoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
